import axios from "../../axios";

const getRoles = async () => {
  try {
    const { data } = await axios.get(`/roles/`);
    console.log(data, "roles");
    return data?.rows;
  } catch (e) {
    return null;
  }
};

export default { 
  getRoles 
};